import { render, staticRenderFns } from "./SaitenBox.vue?vue&type=template&id=0c49c170&scoped=true&"
import script from "./SaitenBox.vue?vue&type=script&lang=ts&"
export * from "./SaitenBox.vue?vue&type=script&lang=ts&"
import style0 from "./SaitenBox.vue?vue&type=style&index=0&id=0c49c170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c49c170",
  null
  
)

export default component.exports